import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, isVerifyEmail, userToken, logout } from "../../../features/user";
import { setLoading, showMessage} from "../../../features/common";
import axios from "axios";
import { API_200, API_204, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../../Constants';
//import { setLoading} from "../../features/common";
import { useTranslation } from 'react-i18next';
import {checkValidToken, userLoggedIn, navigateTo, getLang, showLoading } from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import ListCard from '../../widgets/ListCard';

export function ProviderAnalytics() {
    const [state, setState] = useState({ analyticsData: {} });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);

    useEffect(()=>{
        (async () => {
            await checkValidToken(navigate, dispatch, false, true, "/start");
            if(userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch)){
                getAnalytics();
            }
        })();
       // eslint-disable-next-line
    },[]);


    const getAnalytics = async () => {
        showLoading(dispatch, true);
        let errorMessage = DEFAULT_ERROR_TEXT;

        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};

        try {
            const reply = await axios.get(`${API_URL }/provider/analytics`, config);
            showLoading(dispatch, false);
            // console.log(reply.data.dateOfBirth);
            if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_200) {

                setState({
                    ...state,
                    analyticsData: reply.data
                });
            }
        } catch (e) {
            showLoading(dispatch, false);
            dispatch(showMessage({message : errorMessage}));
        }
    }

    const getPieChart = (amount1, amount2) =>{
        const total = amount1 + amount2;
        const pct1 =  amount1/total*100;
        const from = 55-amount1/total*160;
        //const pct2 =  amount2/total*100;
        return `conic-gradient(from ${from}deg, #932790 ${pct1}%, white ${pct1}%, white ${100}%)`;
    }


    return (
        <Frame showMenu={true} showNav={true}>
            <div className='main provider-analytics'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                        <Background >
                            <div className='right-main-inner mt70'>
                                <div className='text-align-center font-40 font-bold color-550952 mt40'>{t("general_overview")}</div>

                                <div className='border-AA93FF background-AA93FF mt20'>
                                    <div className='background-white pt5 pb5'>
                                        <div className='text-align-center font-25 color-550952'>{t("profile_activity")}</div>
                                    </div>
                                    <div className='center-div'>
                                        <div className='width-80'>
                                            <div className='flex justify-content-space-between font-20 font-bold color-white mt15 mb5'>
                                                <div>{t("profile_visits")}</div>
                                                <div className=''>
                                                    {state.analyticsData.profile_visits}
                                                    {state.analyticsData.profile_visits_pct && <div className='font-10 color-white'>
                                                        {state.analyticsData.profile_visits_pct}%
                                                    </div>}
                                                </div>
                                            </div>
                                            <div className='flex justify-content-space-between font-20 font-bold color-white mt15 mb5'>
                                                <div>{t("clicks_on_packages")}</div>
                                                <div className=''>
                                                    {state.analyticsData.clicks_on_packages}
                                                    {state.analyticsData.clicks_on_packages_pct && <div className='font-10 color-white'>
                                                        {state.analyticsData.clicks_on_packages_pct}%
                                                    </div>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className='border-AA93FF background-AA93FF mt20'>
                                    <div className='background-white pt5 pb5'>
                                        <div className='text-align-center font-25 color-550952'>{t("accounts_that_you_reached")}</div>
                                    </div>
                                    <div className='analytics-box flex justify-content-center align-items-center font-15 font-bold color-550952 mt10 mb10'>
                                        <div></div>
                                        <div className='height-100 flex flex-direction-column align-items-center text-align-center m-width-25 width-25 mt5 pr20 pl20'>
                                            <div className=''>{state.analyticsData.below_30}%</div>    
                                            <div>{t("below_30_years_old")}</div>                                        
                                        </div>
                                        <div className='pie-box relative center-div width-50 mt15 mb15'>
                                            <div className='pie' style={{backgroundImage: getPieChart(state.analyticsData.below_30, state.analyticsData.above_30)}}>
                                                <div className='pie-center'></div> 
                                            </div>
                                            <div className='pie-amount1'>{state.analyticsData.below_30}%</div>
                                            <div className='pie-amount2'>{state.analyticsData.above_30}%</div>   
                                        </div>
                                        <div className='height-100 flex flex-direction-column justify-content-end align-items-center text-align-center m-width-25 width-25 mb5 pr20 pl20'>
                                            <div className=''>{state.analyticsData.above_30}%</div>    
                                            <div>{t("above_30_years_old")}</div>                                        
                                        </div>
                                        <div></div>
                                    </div>
                                </div>

                                <div className='border-AA93FF background-AA93FF mt20'>
                                    <div className='background-white pt5 pb5'>
                                        <div className='text-align-center font-25 color-550952'>{t("accounts_that_you_reached")}</div>
                                    </div>
                                    <div className='analytics-box flex justify-content-center align-items-center font-15 font-bold color-550952 mt10 mb10'>
                                        <div></div>
                                        <div className='height-100 flex flex-direction-column align-items-center text-align-center m-width-25 width-25 mt5 pr20 pl20'>
                                            <div className=''>{state.analyticsData.visits_from_men}%</div>    
                                            <div>{t("visits_from_men")}</div>                                        
                                        </div>
                                        <div className='pie-box relative center-div width-50 mt15 mb15'>
                                            <div className='pie lang-dir-img' style={{backgroundImage: getPieChart(state.analyticsData.visits_from_men, state.analyticsData.visits_from_women)}}>
                                                <div className='pie-center'></div>
                                            </div>
                                            <div className='pie-amount1'>{state.analyticsData.visits_from_men}%</div>
                                            <div className='pie-amount2'>{state.analyticsData.visits_from_women}%</div>  
                                        </div>

                                        <div className='height-100 flex flex-direction-column justify-content-end align-items-center text-align-center m-width-25 width-25 mb5 pr20 pl20'>
                                            <div className=''>{state.analyticsData.visits_from_women}%</div>    
                                            <div>{t("visits_from_women")}</div>                                        
                                        </div>  
                                        <div></div>
                                    </div>
                                </div>
                            </div>
                        </Background>
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}